import Cookies from "js-cookie";
import { PlacementExamAPI } from "../../Admin/apis/PlacementExamAPI";
import { toast } from "react-toastify";
import { useState } from "react";

const AdminImportPlacementExamResults = () => {
  const semester = Cookies.get("semester");
  const [file, setFile] = useState<File | null>();

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    alert("test");
    const fileUploaded: File | null =
      event.target.files == null ? null : event.target.files[0];
    setFile(fileUploaded);
  };
  const handleSubmit = async () => {
    const placementExamApi = new PlacementExamAPI();
    await placementExamApi
      .ImportResults({
        term: Number(semester),
        results: file!,
      })
      .then((d) => {
        if (d.result) {
          toast.success("updated!");
        } else {
          toast.error("Falied");
        }
      });
  };

  return (
    <>
      <input
        type="file"
        accept=".csv,.xls,.xlsx"
        required={true}
        onChange={handleChange}
      />
      <input className="btn" onClick={handleSubmit} value={"Upload file"} />
    </>
  );
};

export default AdminImportPlacementExamResults;
